let env = process.env;
let envVariables = {};

Object.keys(env).forEach( variable => {
    let keys = variable.split('_');
    if ( `${keys[0]}_${keys[1]}` == 'REACT_APP' ){
        if (variable == 'REACT_APP_DOMAIN'){
            envVariables[variable] = env[variable];
        } else {
            envVariables[variable] = env['REACT_APP_DOMAIN'] + env[variable];
        }
    } else {
        envVariables[variable] = env[variable];
    }
})

export default envVariables;